import { Edit } from '@mui/icons-material';
import { formatTranslation } from 'intl';
import { ProjectSetupTranslationKeys } from 'intl/keys';
import { Box, Divider, Grid } from '@mui/material';
import { ButtonTextIcon, secondaryActionButtonSx } from 'components/general';
import { MemoForbiddenTooltip } from 'components/general/ForbiddenTooltip/ForbiddenTooltip';
import { MemoPreviewField } from 'components/general/PreviewField';
import { useAppNavigation } from 'contexts/navigation';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { CommonTranslationKeys } from 'intl/keys';

interface SingleOrganizationProps {
  _id: string;
  name: string;
  label: string;
  contactEmail: string;
  logoUsedInPdfHeadersSignedUrl?: string;
}

export const SingleOrganization = (
  props: SingleOrganizationProps
): React.ReactElement => {
  //TODO https://hustro.atlassian.net/browse/PT-3821
  const { _id, name, label, contactEmail, logoUsedInPdfHeadersSignedUrl } =
    props;

  const intl = useIntl();
  const { canEditOrganization } = usePermissions();
  const editPermission = canEditOrganization();

  const { goToOrganizationEdit } = useAppNavigation();

  const edit = useCallback((): void => {
    goToOrganizationEdit(_id);
  }, [_id, goToOrganizationEdit]);
  return (
    <Box sx={{ px: 4, py: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={8}>
          <h1>{label}</h1>
        </Grid>
        <Grid item xs={12} sm={4} sx={{ my: 'auto' }}>
          <MemoForbiddenTooltip
            visibleWhen={!editPermission.permission}
            reason={editPermission.reason}
            inlined
          >
            <ButtonTextIcon
              disabled={!editPermission.permission}
              startIcon={Edit}
              onClick={edit}
              sx={secondaryActionButtonSx}
            >
              {formatTranslation(intl, CommonTranslationKeys.edit,)}
            </ButtonTextIcon>
          </MemoForbiddenTooltip>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <MemoPreviewField
            label={formatTranslation(intl, ProjectSetupTranslationKeys.label)}
            value={label}
            dense={true}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <MemoPreviewField
            // className={specificClasses.field}
            label={formatTranslation(intl, ProjectSetupTranslationKeys.name)}
            value={name}
            dense={true}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <MemoPreviewField
            label={formatTranslation(intl, ProjectSetupTranslationKeys.contactEmail )}
            value={contactEmail}
            dense={true}
          />
        </Grid>
        {logoUsedInPdfHeadersSignedUrl && (
          <Grid item xs={12} sx={{ p: 2 }}>
            <img
              src={logoUsedInPdfHeadersSignedUrl}
              style={{ width: '100%', height: '100%', maxWidth: '300px' }}
              data-qa='organization-logo'
              alt='This logo is used in pdf headers'
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
